import LogRocket from 'logrocket'

import { adminUri } from '@fv/client-core'

import { useOlarkEvent } from './olarkEvents'
import {
  type OlarkOperatorCommandEvent,
  type OlarkVisitorConversationSync,
  useOlarkCommands,
} from './useOlarkCommands'
import { useOlarkStore } from './useOlarkStore'

export type { OlarkOperatorCommandEvent } from './useOlarkCommands.js'

export const useOlarkHooks = (visitor: OlarkVisitorConversationSync): void => {
  useOlarkSyncVisitorOnBegin(visitor)
  useOlarkSupportOperatorCommands()
}

export const useOlarkOperatorCommand = (
  commandName: string,
  handler: (event: OlarkOperatorCommandEvent) => void,
): void => {
  useOlarkEvent('operatorCommand', event => {
    if (event.command.name === commandName) {
      handler(event)
    }
  })
}

export const useOlarkSyncVisitorOnBegin = (
  visitor: OlarkVisitorConversationSync,
): void => {
  const { syncVisitorOnConversationStart } = useOlarkCommands()

  useOlarkEvent('beginConversation', () => {
    if (!visitor.userId) return

    syncVisitorOnConversationStart(visitor)
  })
}

const adminLoadLinkMessage = (loadId: string | null | undefined): string =>
  loadId
    ? `Admin load link: ${adminUri}/loads/${loadId}`
    : `User isn't currently viewing a load`

export const useOlarkSupportOperatorCommands = (): void => {
  const loadId = useOlarkStore(s => s.loadId)
  const { sendOperatorNotification } = useOlarkCommands()

  useOlarkEvent('operatorCommand', event => {
    if (event.command.name === 'load') {
      sendOperatorNotification(adminLoadLinkMessage(loadId))
    }

    if (
      event.command.name === 'session' ||
      event.command.name === 'logrocket'
    ) {
      LogRocket.getSessionURL(sessionURL => {
        sendOperatorNotification(
          sessionURL
            ? `Logrocket session: ${sessionURL}`
            : 'No session available',
        )
      })
    }
  })
}
